import React from "react";
import styled from "styled-components";
import DisappearingTile from "components/ui/DisappearingTile";
import InstitutionSearch from "./InstitutionSearch";
import FunnelExplorer from "./FunnelExplorer";
import Dashboard from "./Dashboard";

const Wrapper = styled.div`
  display: grid;
  gap: 36px;
`;

const Home = () => (
  <Wrapper>
    <Dashboard />

    <DisappearingTile size="xl">
      <FunnelExplorer />
    </DisappearingTile>

    <DisappearingTile size="xl">
      <InstitutionSearch />
    </DisappearingTile>
  </Wrapper>
);

export default Home;
